module.exports = __webpack_public_path__ + "static/img/2.3e56b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news15/2.png
// module id = q2O2
// module chunks = 1